// extracted by mini-css-extract-plugin
export default {"header":"header_header__Ic2V0","avatar":"header_avatar__qzJWT","currentVendor":"header_currentVendor__eLJ1k","icon":"header_icon__MlUQt","iconWrapper":"header_iconWrapper__IYPqV"};